module.exports = __webpack_public_path__ + "069a8f5a0f9aa6614c55e6f61e68652d.svg";